import React, { useEffect, useState } from 'react'
import { CSSForSelect15vWWidth, handleErrorToast, ProgressModal } from '../CustomFunctions';
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import { AddwithWhiteCircle } from '../AllSvg';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import { CarFrontIcon, X } from 'lucide-react';

const TransportationBOQBulk = ({ id, getTransportation, logData, transportationList }) => {
    const [show, setShow] = useState(false);
    const [designationCache, setDesignationCache] = useState({});
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState([{
        vehicle_description: "",
        during_construction_period: "",
        during_dlp_OM_period: "",
        eot_details: [],

        rate: "",
        project: id,
        random_value_of_changes: "",
        reason_of_change: "",

    }]);

    const [eotObjects, setEotObjects] = useState([]);

    useEffect(() => {
        if (Array.isArray(transportationList) && transportationList.length > 0) {

            const eotLength = transportationList[0]?.eot_details?.length || 0;

            if (eotLength > 0) {

                const newEots = Array.from({ length: eotLength }, () => ({
                    rate: 0,
                    cp: 0,
                    dlp: 0,
                    t_month: 0,
                    boqId: transportationList[0].id,
                    total_amount: 0,
                }));

                setEotObjects(newEots);

                setFormData((prev) =>
                    prev.map((item) => ({
                        ...item,
                        eot_details: newEots
                    }))
                );
            }
        }
    }, [transportationList]);

    useEffect(() => {
        if (!Array.isArray(transportationList) || transportationList.length === 0) return;

        const anyReasonFilled = transportationList.some(
            (item) =>
                item.reason_of_change !== "null" &&
                item.reason_of_change !== null &&
                item.reason_of_change !== ""
        );

        let selectedData = null;

        if (anyReasonFilled) {
            selectedData = [...transportationList]
                .filter(
                    (item) =>
                        item.random_value_of_changes &&
                        !isNaN(new Date(item.random_value_of_changes))
                )
                .sort(
                    (a, b) =>
                        new Date(b.random_value_of_changes) -
                        new Date(a.random_value_of_changes)
                )[0];
        } else {
            selectedData = transportationList.find(
                (item) =>
                    item.random_value_of_changes &&
                    (item.reason_of_change === "null" ||
                        item.reason_of_change === null ||
                        item.reason_of_change === "")
            );
        }

        if (selectedData?.random_value_of_changes) {
            setFormData((prev) =>
                prev.map((item) => ({
                    ...item,
                    random_value_of_changes: selectedData.random_value_of_changes,
                    reason_of_change: selectedData.reason_of_change || "",
                }))
            );
        }
    }, [transportationList]);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = [...prev];

            updated[index] = {
                ...updated[index],
                [name]: value
            };

            return updated;
        });
    };


    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData([{
            vehicle_description: "",
            during_construction_period: "",
            during_dlp_OM_period: "",
            eot_details: [],
            rate: "",
            project: id,
            random_value_of_changes: "",
            reason_of_change: "",
        }])
    }


    const [loading, setLoading] = useState(false); //loading logic
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);



    const handleAddRow = () => {
        setFormData((prev) => [
            ...prev,
            {
                vehicle_description: "",
                during_construction_period: "",
                during_dlp_OM_period: "",
                eot_details: eotObjects.length > 0 ? eotObjects : [],

                rate: "",
                project: id,
                random_value_of_changes: "",
                reason_of_change: "",
            }
        ]);
    };


    const handleRemoveRow = (index) => {
        setFormData((prev) => {
            if (prev.length === 1) return prev; // prevent removing last row

            const updated = [...prev];
            updated.splice(index, 1);

            return updated;
        });
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["vehicle_description",
            "during_construction_period",
            "during_dlp_OM_period",
            "rate",];

        formData.forEach((item, index) => {
            requiredFields.forEach((field) => {
                if (!item[field]) {
                    newErrors[`${index}_${field}`] =
                        `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/bulkBOQTransportPost/`,
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            setUploadProgress(percentCompleted);
                        },
                    }
                );

                if (res.status === 201) {
                    await getTransportation();

                    handleClose();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId); // Close loading toast
                        toast.success("BOQ Added Successfully"); // Show success toast
                    }, 4000);
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err, loadingToastId);
            } finally {

                setTimeout(() => {
                    setShowProgressModal(false);
                }, 2000); // Hide after 3 seconds

                setTimeout(() => {
                    setLoading(false); //loading logic
                    toast.dismiss(loadingToastId);
                }, 4000)

            }
        }
    };
    console.log(formData, "formData");


    // return (
    //     <>
    //         <button title="Update employee BOQ" className="upload-svg flex-row" onClick={handleShow}>

    //             <AddwithWhiteCircle /> Transportation BOQ
    //         </button>
    //         {
    //             showProgressModal ?
    //                 <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
    //                 <Modal
    //                     show={show}
    //                     onHide={handleClose}
    //                     dialogClassName="width-90vw-Modal"
    //                 >
    //                     <Modal.Header closeButton >
    //                         <Modal.Title>Add Transportation Data for BOQ</Modal.Title>

    //                     </Modal.Header>


    //                     <Modal.Body>
    //                         <div className="parent-div">
    //                             <div className="bdy-div">
    //                                 <div className='addrowcss'>
    //                                     <button className="upload-svg" onClick={handleAddRow}>
    //                                         <AddwithWhiteCircle /> Add Row
    //                                     </button>
    //                                 </div>

    //                                 <div className="flex-row justify-center">
    //                                     <table className="table-css ">
    //                                         <thead className="table-heading">
    //                                             <tr className="custom-table-head-tr width-10vw">
    //                                                 <th className="table-heading-text text-left-sr" >S no.</th>
    //                                                 <th className="table-heading-text text-center">Description of Vehicles <br /> <span className="required">(Read-Only)</span></th>
    //                                                 <th className="table-heading-text text-center">Duration of Construction Period <br /><span className="required">(In-Months)</span></th>
    //                                                 <th className="table-heading-text text-center">Duration of DLP <br /><span className="required">(In-Months)</span></th>
    //                                                 <th className="table-heading-text text-center">Total Period <br /> <span className="required">(Read-Only)</span></th>
    //                                                 <th className="table-heading-text text-center">Rate  <br /> <span className="required">(Monthly-Rate)</span></th>
    //                                             </tr>
    //                                         </thead>

    //                                         <tbody>

    //                                             {formData.map((entry, index) => (
    //                                                 <tr key={index} className="custom-table-head-td ">

    //                                                     <td className="align-left width-5vw" >
    //                                                         {formData.length !== 1 &&
    //                                                             <button
    //                                                                 type="button"
    //                                                                 style={{ marginLeft: "22px", marginTop: "-7px" }}
    //                                                                 className='removebuttoncss'
    //                                                                 disabled={formData.length === 1}
    //                                                                 onClick={() => handleRemoveRow(index)}
    //                                                             >
    //                                                                 X
    //                                                             </button>
    //                                                         } {index + 1}.
    //                                                     </td>
    //                                                     <td>
    //                                                         <div title="Vehicle Description" className="flex-column align-items-center">
    //                                                             <input
    //                                                                 className={`form-input width-20vw  ${errors[`${index}_vehicle_description`] ? "error" : ""}`}
    //                                                                 id={`vehicle_description_${index}`}
    //                                                                 name="vehicle_description"
    //                                                                 type="text"
    //                                                                 value={entry.vehicle_description}
    //                                                                 onChange={(e) => handleInputChange(e, index)}


    //                                                             />
    //                                                             <div>
    //                                                                 {errors[`${index}_vehicle_description`] && (
    //                                                                     <span className="error-message font-size-text ">{errors[`${index}_vehicle_description`]}</span>
    //                                                                 )}
    //                                                             </div>
    //                                                         </div>
    //                                                     </td>

    //                                                     <td className=''>
    //                                                         <div title="CP" className="flex-column align-items-center align-items-center">
    //                                                             <input
    //                                                                 className={`form-input width-5vw ${errors[`${index}_during_construction_period`] ? "error" : ""}`}
    //                                                                 id={`during_construction_period_${index}`}
    //                                                                 name="during_construction_period"
    //                                                                 type="text"
    //                                                                 value={entry.during_construction_period}
    //                                                                 onChange={(e) => handleInputChange(e, index)}

    //                                                             />
    //                                                             <div>
    //                                                                 {errors[`${index}_during_construction_period`] && (
    //                                                                     <span className="error-message font-size-text ">{errors[`${index}_during_construction_period`]}</span>
    //                                                                 )}
    //                                                             </div>
    //                                                         </div>
    //                                                     </td>
    //                                                     <td>
    //                                                         <div title="O&M Period" className="flex-column align-items-center">
    //                                                             <input
    //                                                                 className={`form-input-date  width-5vw  ${errors[`${index}_during_dlp_OM_period`] ? "error" : ""}`}
    //                                                                 id={`during_dlp_OM_period_${index}`}
    //                                                                 name="during_dlp_OM_period"
    //                                                                 type="number"
    //                                                                 value={entry.during_dlp_OM_period}
    //                                                                 onChange={(e) => handleInputChange(e, index)}

    //                                                             />
    //                                                             <div>
    //                                                                 {errors[`${index}_during_dlp_OM_period`] && (
    //                                                                     <span className="error-message font-size-text ">{errors[`${index}_during_dlp_OM_period`]}</span>
    //                                                                 )}
    //                                                             </div>
    //                                                         </div>
    //                                                     </td>
    //                                                     <td>
    //                                                         <div title="Total Period" className="flex-column align-items-center">
    //                                                             <input
    //                                                                 className={`form-input-date  width-5vw  ${errors[`${index}_num_of_man_month`] ? "error" : ""}`}
    //                                                                 id={`num_of_man_month_${index}`}
    //                                                                 name="num_of_man_month"
    //                                                                 type="text"
    //                                                                 value={Number(entry.during_construction_period || 0) + Number(entry.during_dlp_OM_period || 0)} // Calculate and display the sum
    //                                                                 onChange={(e) => handleInputChange(e, index)}
    //                                                                 readOnly
    //                                                             />
    //                                                             <div>
    //                                                                 {errors[`${index}_num_of_man_month`] && (
    //                                                                     <span className="error-message font-size-text ">{errors[`${index}_num_of_man_month`]}</span>
    //                                                                 )}
    //                                                             </div>
    //                                                         </div>
    //                                                     </td>
    //                                                     <td>
    //                                                         <div title="Rate" className="flex-column align-items-center">
    //                                                             <input
    //                                                                 className={`form-input-date  width-5vw  ${errors[`${index}_rate`] ? "error" : ""}`}
    //                                                                 id={`rate_${index}`}
    //                                                                 name="rate"
    //                                                                 type="text"
    //                                                                 value={entry.rate}
    //                                                                 onChange={(e) => handleInputChange(e, index)}

    //                                                             />
    //                                                             <div>
    //                                                                 {errors[`${index}_rate`] && (
    //                                                                     <span className="error-message font-size-text ">{errors[`${index}_rate`]}</span>
    //                                                                 )}
    //                                                             </div>
    //                                                         </div>
    //                                                     </td>


    //                                                 </tr>
    //                                             ))}

    //                                         </tbody>

    //                                     </table>
    //                                 </div>
    //                                 <div className="button-models">
    //                                     <button
    //                                         className="model-button-cancel model-button font-weight500"
    //                                         onClick={handleClose}
    //                                     >
    //                                         Cancel
    //                                     </button>
    //                                     <button
    //                                         type="submit"
    //                                         className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
    //                                         disabled={loading}
    //                                         onClick={handleSubmit}
    //                                     >
    //                                         Submit
    //                                     </button>
    //                                 </div>

    //                             </div>
    //                         </div>
    //                         <ToastContainer
    //                             position="top-center"
    //                             autoClose={1000}
    //                             hideProgressBar={false}
    //                             newestOnTop={true}
    //                             closeOnClick
    //                             rtl={false}
    //                             pauseOnFocusLoss
    //                             draggable
    //                             pauseOnHover
    //                         />

    //                     </Modal.Body >

    //                 </Modal >
    //         }
    //     </>
    // )


    return (
        <>
            <button
                title="Add Transportation BOQ"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <CarFrontIcon />

                Add Transportation
            </button>

            {showProgressModal ?
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <CarFrontIcon />
                            Add Transportation Data for BOQ
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-actions">
                                    <button className="eb-bulk-add-row-btn" onClick={handleAddRow}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="8" x2="12" y2="16" />
                                            <line x1="8" y1="12" x2="16" y2="12" />
                                        </svg>
                                        Add Row
                                    </button>
                                </div>

                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss" style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                                        <table className="eb-bulk-table">
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th eb-bulk-th-rank">
                                                        <span className="eb-bulk-th-label">S No.</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-designation">
                                                        <span className="eb-bulk-th-label">Description of Vehicles</span>
                                                        <span className="eb-bulk-th-sub">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-period">
                                                        <span className="eb-bulk-th-label">Duration of Construction Period</span>
                                                        <span className="eb-bulk-th-sub">(In-Months)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-period">
                                                        <span className="eb-bulk-th-label">Duration of DLP</span>
                                                        <span className="eb-bulk-th-sub">(In-Months)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-total">
                                                        <span className="eb-bulk-th-label">Total Period</span>
                                                        <span className="eb-bulk-th-sub">(Read-Only)</span>
                                                    </th>
                                                    <th className="eb-bulk-th eb-bulk-th-rate">
                                                        <span className="eb-bulk-th-label">Rate</span>
                                                        <span className="eb-bulk-th-sub">(Monthly-Rate)</span>
                                                        <span className="eb-bulk-required">*</span>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td eb-bulk-td-rank">
                                                            <div className="eb-bulk-rank-container">
                                                                {formData.length !== 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="eb-bulk-remove-btn"
                                                                        disabled={formData.length === 1}
                                                                        onClick={() => handleRemoveRow(index)}
                                                                    >
                                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                            <line x1="18" y1="6" x2="6" y2="18" />
                                                                            <line x1="6" y1="6" x2="18" y2="18" />
                                                                        </svg>
                                                                    </button>
                                                                )}
                                                                <span className="eb-bulk-total-value">{index + 1}.</span>
                                                            </div>
                                                        </td>

                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input ${errors[`${index}_vehicle_description`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`vehicle_description_${index}`}
                                                                    name="vehicle_description"
                                                                    type="text"
                                                                    style={{ textAlign: "start" }}
                                                                    value={entry.vehicle_description}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="Enter vehicle description"
                                                                />
                                                                {errors[`${index}_vehicle_description`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_vehicle_description`]}</span>
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_construction_period`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`during_construction_period_${index}`}
                                                                    name="during_construction_period"
                                                                    type="text"
                                                                    value={entry.during_construction_period}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="0"
                                                                />
                                                                {errors[`${index}_during_construction_period`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_during_construction_period`]}</span>
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_during_dlp_OM_period`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`during_dlp_OM_period_${index}`}
                                                                    name="during_dlp_OM_period"
                                                                    type="number"
                                                                    value={entry.during_dlp_OM_period}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="0"
                                                                />
                                                                {errors[`${index}_during_dlp_OM_period`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_during_dlp_OM_period`]}</span>
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td className="eb-bulk-td eb-bulk-td-total">
                                                            <span className="eb-bulk-total-value">
                                                                {Number(entry.during_construction_period || 0) + Number(entry.during_dlp_OM_period || 0)}
                                                            </span>
                                                        </td>

                                                        <td className="eb-bulk-td">
                                                            <div className="eb-bulk-input-wrapper">
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_rate`] ? "eb-bulk-input-error" : ""}`}
                                                                    id={`rate_${index}`}
                                                                    name="rate"
                                                                    type="text"
                                                                    value={entry.rate}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    placeholder="₹ 0.00"
                                                                />
                                                                {errors[`${index}_rate`] && (
                                                                    <span className="eb-bulk-error-text">{errors[`${index}_rate`]}</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button
                                        className="eb-bulk-btn eb-bulk-btn-cancel"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}

export default TransportationBOQBulk